import script from "./PageMention.vue?vue&type=script&lang=ts"
export * from "./PageMention.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__